class Dater {
  formatar(date, format = 'dd/mm/yyyy') {
    this.data = new Date(
      new Date(date).toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' })
    )
    this.pegarData()
    this.pegarTempo()
    this.format = format
    this.aplicarValores()
    return this.format
  }

  aplicarValores = () => {
    const arr = Object.keys(this.dataContexto)
    arr.forEach(item => {
      this.format = this.format.replace(item, this.dataContexto[item])
    })
  }

  pegarData() {
    const stringYear = this.data.getFullYear().toString()
    this.dataContexto = {
      yyyy: this.adicionarZero(this.data?.getFullYear()),
      yy: stringYear.slice(stringYear.length - 2),
      mm: this.adicionarZero(this.data.getMonth() + 1),
      MM: this.meses[this.data.getMonth()]?.nome,
      dd: this.adicionarZero(this.data.getDate())
    }
  }

  pegarTempo() {
    const time = {
      hours: this.adicionarZero(this.data.getHours()),
      mins: this.adicionarZero(this.data.getMinutes()),
      secs: this.adicionarZero(this.data.getSeconds())
    }
    this.dataContexto = { ...this.dataContexto, ...time }
  }

  meses = [
    { mes: 1, nome: 'Janeiro' },
    { mes: 2, nome: 'Fevereiro' },
    { mes: 3, nome: 'Março' },
    { mes: 4, nome: 'Abril' },
    { mes: 5, nome: 'Maio' },
    { mes: 6, nome: 'Junho' },
    { mes: 7, nome: 'Julho' },
    { mes: 8, nome: 'Agosto' },
    { mes: 9, nome: 'Setembro' },
    { mes: 10, nome: 'Outubro' },
    { mes: 11, nome: 'Novembro' },
    { mes: 12, nome: 'Dezembro' }
  ]

  adicionarZero = i => {
    if (i < 10) {
      i = '0' + i
    }
    return i
  }
}

export default () => new Dater()
